import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ContentContext = createContext({ t: (k, fb) => fb || k, logo: null, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [logo, setLogo] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [{ data: c }, { data: l }] = await Promise.all([
        api.get("/content"),
        api.get("/logo"),
      ]);
      setContent(c || {});
      setLogo(l?.data_url || null);
    } catch (e) {
      // keep defaults
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const t = useCallback((key, fallback) => {
    return content[key] ?? fallback ?? key;
  }, [content]);

  return (
    <ContentContext.Provider value={{ t, logo, refresh, content }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
